// routes
import { PATH_PHARMACY_DASHBOARD } from '../../../routes/paths';
// components
import SvgIconStyle from '../../../components/SvgIconStyle';

// ----------------------------------------------------------------------

const getIcon = (name) => <SvgIconStyle src={`/icons/${name}.svg`} sx={{ width: 1, height: 1 }} />;

const ICONS = {
  blog: getIcon('ic_blog'),
  cart: getIcon('ic_cart'),
  chat: getIcon('ic_chat'),
  mail: getIcon('ic_mail'),
  user: getIcon('ic_user'),
  kanban: getIcon('ic_kanban'),
  banking: getIcon('ic_banking'),
  calendar: getIcon('ic_calendar'),
  ecommerce: getIcon('ic_ecommerce'),
  analytics: getIcon('ic_analytics'),
  dashboard: getIcon('ic_dashboard'),
  booking: getIcon('ic_booking'),
};

const navConfig = [
  // GENERAL
  // ----------------------------------------------------------------------
  {
    subheader: 'general',
    items: [
      { title: 'Dashboard', path: PATH_PHARMACY_DASHBOARD.general.dashboard, icon: ICONS.user },
      { title: 'Users', path: PATH_PHARMACY_DASHBOARD.general.users, icon: ICONS.user },
      { title: 'Pharmacy Medicines', path: PATH_PHARMACY_DASHBOARD.general.pharmacyMedicine, icon: ICONS.user },
      { title: 'Articles', path: PATH_PHARMACY_DASHBOARD.general.article, icon: ICONS.user },
      { title: 'Orders', path: PATH_PHARMACY_DASHBOARD.general.orders, icon: ICONS.chat },
      { title: 'Offers', path: PATH_PHARMACY_DASHBOARD.general.offer, icon: ICONS.user },
      { title: 'Home Setting', path: PATH_PHARMACY_DASHBOARD.general.homePage, icon: ICONS.user },
      { title: 'Chats', path: PATH_PHARMACY_DASHBOARD.chat.root, icon: ICONS.chat },
    ],
  },

  // MANAGEMENT
  // ----------------------------------------------------------------------
];

export default navConfig;
